import { forwardRef, type InputHTMLAttributes } from 'react';

import { cx } from '../utils/cx';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/**
 * Base text input. Spread the bind object from `Field`'s render prop onto
 * this component so id/aria-describedby/aria-invalid stay wired correctly:
 *
 *   <Field label="Nom complet">
 *     {(bind) => <Input {...bind} value={name} onChange={...} />}
 *   </Field>
 */
export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, ...rest },
  ref,
) {
  return <input ref={ref} className={cx('ecom-input', className)} {...rest} />;
});
